export default "__VITE_ASSET__C75UfkXo__"